<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized" class="container-fluid">
  <form class="form" (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
    <div class="sticky-top pt-2">
      <div class="row">
        <div class="col-sm-6 pull-left">
          <h4 *ngIf="exhibitId" class="mb-3">Edit Exhibit</h4>

        </div>
        <div class="col-sm-6 text-right pull-right">
          <button class="btn btn-outline-dark mr-2" (click)="onCancel()" type="button">Cancel</button>
          <button class="btn btn-admin-primary" [promiseBtn]="submitComplete" type="submit">Save</button>
        </div>
      </div>
    </div>

    <div class="card mb-5">
      <div class="card-header pb-0">
        <div class="row p-0">
          <div class="col-md-6">
            <h5 class="m-0">Exhibit details</h5>
          </div>
          <div class="col-md-6 p-0 text-right"></div>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-8 mb-3">
            <label for="firstName">Exhibit Name</label>
            <i class="fa fa-asterisk"></i>
            <input type="text" class="form-control" formControlName="title" />
            <div class="invalid-message">
              <div>Exhibit Name is required</div>
            </div>
          </div>

          <div *ngIf="!exhibitId" class="col-md-6 mb-3">
            <label for="country">Admin Email</label>
            <i class="fa fa-asterisk"></i>
            <input type="text" class="form-control" formControlName="emailToInvite" />
            <div class="invalid-message">
              <div>Last Name is required</div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="exhibitId">
          <div class="row">
            <div class="col-md-6">
              <h5>Users</h5>
            </div>
            <div class="col-md-6 text-right">
              <button type="button" class="btn btn-admin-primary btn-xs" (click)="addUser()">Add User</button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="card p-0">
                <div class="card-body p-0">
                  <div class="row">
                    <div class="col-md-12">
                      <table class="table table-hover mb-0">
                        <thead class="bg-light">
                          <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th class="text-right">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let user of exhibit.users">
                            <td>
                              <img class="avatar u-sm-avatar rounded-circle mr-2" [fallback]="'fetch-avatar?userId=' + user.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ user.id }}-avatar.png"/>

                              {{ user.lastName }}, {{ user.firstName }}
                            </td>

                            <td>{{ user.email }}</td>

                            <td class="text-right"><a href="javascript:void(0)">Remove</a></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </form>
</div>
